module.exports = __webpack_public_path__ + "static/media/5DPO17.b5f888b3.jpg";